import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEllipsisV,
  faTable,
  faSortUp,
  faSortDown,
  faCaretUp,
  faCaretDown,
  faChartBar,
} from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { Bar } from "react-chartjs-2";
import FilterContext from "../../routes/FilterContext";
import Table from "react-bootstrap/Table";
class KeyDocuments extends React.Component {
  static contextType = FilterContext;

  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="widget widgetTable latestNews keyDocs">
        <div className="row">
          <div className="col-lg-12 text-start colorLightBlue widgetTableHeader">
            <p>Key Documents</p>
          </div>
          <div className="col-lg-12 mt-2">
            <Table responsive hover>
              <tbody>
                <tr>
                  <td>
                    <img
                      alt="News Outlet Icon"
                      src="/edge/images/money_control.png"
                    />
                  </td>
                  <th>
                    Latest Annual Report of DLF Cyber City Developers FY 2021
                  </th>
                </tr>
                <tr>
                  <td>
                    <img alt="News Outlet Icon" src="/edge/images/et.png" />
                  </td>
                  <th>
                    Latest Quarterly Report of DLF Cyber City Developers Q3 FY
                    2021
                  </th>
                </tr>
                <tr>
                  <td>
                    <img
                      alt="News Outlet Icon"
                      src="/edge/images/money_control.png"
                    />
                  </td>
                  <th>
                    Registered Developer Agreement for New Commercial Project in
                    Chandigarh
                  </th>
                </tr>
              </tbody>
            </Table>
          </div>
        </div>
      </div>
    );
  }
}

export default KeyDocuments;
